import loginStyle from "../../../../../../assets/scss/common/modal/loginModal.module.scss";
import memberStyle from "../../../../../../assets/scss/sub/editMember.module.scss";
import React, {RefObject} from "react";
import {handleOnlyNumberChange} from "../../../../../../util/commonFunctions";
import {ValidateStatus} from "../hooks/useSignupValidator";
import {StyleRequestType} from "../../../../../../types/common";
import {useTranslation} from "react-i18next";

interface Props{
    birthday: string;
    setBirthday: (_: string) => void;
    birthdayValidate: ValidateStatus;
    setBirthdayValidate: (_: ValidateStatus) => void;
    styleRequestType: StyleRequestType;
    birthdayRef?: RefObject<HTMLInputElement>;
}
export function SignupBirthdayField({birthday, setBirthday, birthdayValidate, setBirthdayValidate, styleRequestType, birthdayRef}:Props){
    const { t } = useTranslation("userInfo");
    const styles = styleRequestType === StyleRequestType.SIGN_UP ? loginStyle :  memberStyle;
    return (
        <div className={styles.selectWrapper}>
            <div className={styles.selectTitleWrapper}>
                <span className={styles.highLight}>{t('form.required')}</span>
                <span className={styles.titleText}>{t('form.birthday.label')}</span>
            </div>
            <div className={styles.selectTextFieldWrapper}>
                <input
                    ref={birthdayRef}
                    maxLength={8}
                    type="tel"
                    className={styles.selectText}
                    value={birthday}
                    onInvalid={(e) => e.preventDefault()}
                    onChange={(e) => {
                        handleOnlyNumberChange(e, setBirthday)
                        setBirthdayValidate(ValidateStatus.NONE)
                    }}
                    placeholder={t('form.birthday.placeholder')}
                />
            </div>
            {birthdayValidate === ValidateStatus.UNFILLED &&
                (<span className={styles.validateText}>{t('edit.warning.birthday.unfilled')}</span>)
            }
            {birthdayValidate === ValidateStatus.BELOW_REQUIRED_LENGTH &&
                (<span className={styles.validateText}>{t('edit.warning.birthday.belowLength')}</span>)
            }
            {birthdayValidate === ValidateStatus.INVALID_BIRTHDATE &&
                (<span className={styles.validateText}>{t('edit.warning.birthday.invalidBirthdate')}</span>)
            }
        </div>
    )
}